import { ReactNode } from 'react';
import { ResolveRouteAppScope } from '../resolveDualPathAppScope';
import { AppScopeProvider } from './AppScopeProvider';
import { useParentOrganizationId } from './AppScopeContext';

export type ScopedRouteLayoutProps = {
  resolveScope: ResolveRouteAppScope;
  params: Record<string, string | undefined>;
  pathname: string;
  layout: ReactNode;
};

export function ScopedRouteLayout({
  resolveScope,
  params,
  pathname,
  layout
}: ScopedRouteLayoutProps) {
  const organizationId = useParentOrganizationId();
  const scope = resolveScope(params, organizationId, pathname);
  return <AppScopeProvider scope={scope}>{layout}</AppScopeProvider>;
}
